import type { SortDir } from '../../../lib/table-sort.js';

// 定義は lib/table-sort.ts が持つ（lib 側からも使うため）。既存の import 経路を維持するため再エクスポートする。
export type { SortDir };

/**
 * @graph-stack product-innovation-lab
 * @graph-domain Engineering
 * @graph-business ソート方向アイコン。未ソート時は薄い上下矢印、昇順/降順時はアクセントカラーの単方向矢印を表示
 * @graph-connects none
 */
export function SortIcon({ active, dir }: { active: boolean; dir: SortDir }) {
  if (!active) {
    return (
      <svg className="w-3 h-3 opacity-30 shrink-0" viewBox="0 0 10 14" fill="none">
        <path d="M5 2L8.5 6H1.5L5 2Z" fill="currentColor" />
        <path d="M5 12L1.5 8H8.5L5 12Z" fill="currentColor" />
      </svg>
    );
  }
  return (
    <svg
      className="w-3 h-3 text-[var(--color-accent-primary)] shrink-0"
      viewBox="0 0 10 14"
      fill="none"
    >
      {dir === 'asc' ? (
        <path d="M5 2L8.5 6H1.5L5 2Z" fill="currentColor" />
      ) : (
        <path d="M5 12L1.5 8H8.5L5 12Z" fill="currentColor" />
      )}
    </svg>
  );
}

/**
 * @graph-stack product-innovation-lab
 * @graph-domain Engineering
 * @graph-business クリックでソートを切り替える列ヘッダーボタン。アクティブ列はアクセントカラーで強調し、矢印アイコンで昇順/降順を表示
 * @graph-connects none
 */
export function SortableHeader<K extends string>({
  label,
  sortKey,
  currentKey,
  currentDir,
  onSort,
}: {
  label: string;
  sortKey: K;
  currentKey: K | null;
  currentDir: SortDir;
  onSort: (key: K) => void;
}) {
  const isActive = currentKey === sortKey;
  return (
    <button
      type="button"
      className={`inline-flex items-center gap-1 hover:text-[var(--color-text-primary)] transition-colors ${isActive ? 'text-[var(--color-accent-primary)]' : ''}`}
      onClick={() => {
        onSort(sortKey);
      }}
    >
      {label}
      <SortIcon active={isActive} dir={currentDir} />
    </button>
  );
}
